import {post} from '../utils/ajaxHelper';

/**
 * Handles POST to server for inquiry submission
 *
 * @param {*} inquiryModel
 * @param {*} locale
 * @param {*} useMockData
 */
function postInquiry(inquiryModel, locale, useMockData) {
    const variant = window && window.debugLog && window.debugLog.variant;
    const requestMarker = window && window.debugLog && window.debugLog.requestMarker;
    const url = useMockData
        ? `/pdp/inquiryRequest?useMockData=${useMockData}&useMockLogin=true`
        : `/pdp/inquiryRequest`;

    if (variant) {
        inquiryModel.variant = variant;
    }

    if (requestMarker) {
        inquiryModel.requestMarker = requestMarker;
    }

    inquiryModel.locale = locale;

    return post(url, inquiryModel);
}

export default postInquiry;
export {postInquiry};
